import React from "react"
import { Container, Row, Col } from "reactstrap"
import TileContainer from "../containers/TitleContainer"
import invisiBreak from "../assets/pattern-3.svg"
import sconesImage from "../assets/galleryImages/food/WhatsApp Image 2026-08-05 at 10.38.51 (3).jpeg"
import "./app.css"

const AfternoonTeas = () => {
    return (
        <Container fluid>
            <TileContainer title={"Afternoon Teas"} />
            <Row className="row-m-20">
                <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                        <div style={{ border: "1px solid #333", padding: 20, textAlign: "center", marginBottom: 20 }}>
                            <h3 style={{ marginBottom: 0 }}>Delicious prebookable Afternoon Teas with vegan and GF options.</h3>
                        </div>

                        <p>Our Afternoon Teas are available every day but we do require 24 hour notice.</p>
                        <p>They include 4 varieties of sandwich, usually cheese, ham, egg mayo and tuna mayo, plus a slice of homemade quiche, salad, crisps and coleslaw.</p>
                        <p>This is accompanied by 2 varieties of cake and a scone, with jam, cream and fruit.</p>
                        <p>All dietary requirements can be catered for, at no additional cost.</p>
                        <p><b>£15 per person</b></p>
                        <p>(We do ask for a £5 per person deposit when booking)</p>
                        <img
                            src={sconesImage}
                            alt="Afternoon tea scones"
                            className="shadow-image center"
                            style={{ width: "100%", maxWidth: 700, height: "auto", marginTop: 20 }}
                        />
                    </div>
                </Col>
            </Row>
            <Row className="row-m-20">
                <Col className="remove-padding">
                    <div>
                        <img src={invisiBreak} alt="" className="center" style={{ width: "100%", height: "50%", borderRadius: 5, opacity: 0.5 }} />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default AfternoonTeas